<template>
   <table class="table table-hover" v-bind:style="[ showHeader ? 'border: 1px solid #dcdede;' : '' ]">
                <thead class="thead-third" v-if="columns">
                <slot name="header"></slot>
                <tr>
                    <th class="text-center w-25">{{title}}</th>
                    <th class="text-center w-25">{{formatMoney(totalSaleValue)}}</th>
                    <th class="text-center w-25">Data</th>
                    <th class="text-center w-25">{{totalBrokers}} Corretor(es)</th>
                </tr>
                </thead>
                <thead class="thead-third" v-else>
                <slot name="thead"></slot>
                </thead>
                <tbody>
                <tr v-for="(row,i) in rows" :key="i">
                    <td class="text-center">{{row.nomeCredenciada}}</td>
                    <td class="text-center">{{formatMoney(row.valorTotal)}}</td>
                    <td class="text-center">{{row.data}}</td>
                    <td class="text-center"></td>
                </tr>
                </tbody>
          </table>
</template>

<script>
import tablesalesaccreditedmonth from './tablesalesaccreditedmonth'
export default tablesalesaccreditedmonth
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesbyaccredited/components/tablesalesaccreditedmonth/tablesalesaccreditedmonth.vue